import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserThemeRepositoryImpl } from '../../data/repository/user_theme_repository_impl';

export const useDeleteUserThemeInProgress = () => {
  const repository = new UserThemeRepositoryImpl();
  const queryClient = useQueryClient();

  return useMutation<boolean, Error, void>({
    mutationFn: () => repository.deleteUserThemeInProgress(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userProfile'] });
    },
  });
};
